module.exports = __webpack_public_path__ + "static/media/pic_anfang_wap.e20fd741.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_temperature/pic_anfang_wap.png
// module id = 494
// module chunks = 0